<template>
  <div class="usermidhea-fluid">
    <div class="usermidhea FontSize14 between">
      <div class="flex_start">
        <div class="address center text_hover_shou">
          <div><img src="~assets/base/zuobiao.png" /></div>
          <div class="text">合肥</div>
          <div class="flip90">
            <svg-icon icon-class="jt_right"></svg-icon>
          </div>

          <div class="address_info">
            <div class="city">
              <div class="hot_city_title">热门城市</div>
              <div class="city_name flex_start wrap">
                <span v-for="(item, index) in 25" :key="index" class="name_item"
                  >北京</span
                >
                <span class="name_item all">全部</span>
              </div>
            </div>
            <div class="city">
              <div class="hot_city_title">按首字母选择</div>
              <div class="city_initial around">
                <span
                  v-for="(item, index) in 26"
                  :key="index"
                  @mouseover="selectinitial(item)"
                >
                  A
                </span>
              </div>
              <div class="city_name flex_start wrap">
                <span v-for="(item, index) in 40" :key="index" class="name_item"
                  >北京</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="enter_address usermidhea_text_color">进入合肥站</div>
        <div class="columnitem usermidhea_text_color" @click="tojump('/')">
          首页
        </div>
        <div
          class="columnitem usermidhea_text_color"
          @click="tojump('/question/lawyeronline')"
        >
          法律咨询
        </div>
        <div
          class="columnitem usermidhea_text_color"
          @click="tojump('/findLawyers')"
        >
          找律师
        </div>
        <div class="columnitem usermidhea_text_color" @click="tojump('/laws')">
          法律知识
        </div>
      </div>
      <div class="flex_end">
        <div class="ydl">
          您好，
          <span class="aces">183****2729</span>
          <span class="logout">退出</span>
        </div>
        <div class="web_address center text_hover_shou">
          <div class="web_address_text">网站导航</div>
          <div class="flip90">
            <svg-icon icon-class="jt_right"></svg-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    selectinitial(item) {
      console.log("选中了", item);
    },
    tojump(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
.usermidhea-fluid {
  background-color: #f8f8f8;
  width: 100%;
  height: 100%;
  .usermidhea {
    margin: 0 auto;
    width: 1200px;
    height: 38px;
    line-height: 38px;
    align-items: center;
    color: #999999;

    .usermidhea_text_color {
      &:hover {
        color: #fff;
        background-color: #0465ea;
      }
    }

    .address {
      position: relative;
      padding: 0 10px 0 0;

      img {
        vertical-align: -0.15em;
      }

      .text {
        margin: 0 4px 0 6px;
      }
      &:hover {
        .address_info {
          top: 38px;
          visibility: visible;
          opacity: 1;
          transition: all 0.5s;
        }
      }
      .address_info {
        position: absolute;
        z-index: 999;
        visibility: hidden;
        opacity: 0;
        width: 610px;
        min-height: 350px;
        padding: 18px 30px;
        top: 58px;
        left: 0;
        box-shadow: 0 4px 20px rgb(0 0 0 / 5%);
        background-color: #fff;
        .city {
          margin-bottom: 20px;
          .city_name {
            position: relative;
          }
          &::after {
            content: "";
            display: block;
            height: 0;
            clear: both;
            visibility: hidden;
          }

          .hot_city_title {
            color: #999;
            font-size: 16px;
          }
          .city_initial {
            font-size: 16px;
            color: #333;
            font-weight: 600;
            cursor: pointer;
            span:hover {
              color: #0057ff;
            }
          }
          .name_item {
            color: #333;
            line-height: 32px;
            width: 8%;
            &:hover {
              color: #0057ff;
            }
          }

          .all {
            position: absolute;
            bottom: 0;
            right: -10px;
            color: #0057ff;
            &:hover {
              color: red;
            }
          }
        }
      }
    }
    .enter_address {
      color: #0465ea;
      height: 38px;
      padding: 0 10px;
      margin-left: 10px;
    }
    .columnitem {
      padding: 0 10px;
      cursor: pointer;
    }
    .ydl {
      .aces {
        color: #0057ff;
      }
      .logout {
        margin-left: 10px;
        cursor: pointer;
      }
    }
    .web_address {
      .web_address_text {
        margin: 0 6px 0 10px;
      }
    }
  }
}
</style>